import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { EarningSchema } from "model/_base/earning";
import { AffiliateSchema, AffiliateReadSchema } from "model/_base/affiliates";

export const DataSchema = EarningSchema.clone().transform(transformSnakeToCamel).shape({
  partner: AffiliateReadSchema,
});

export const EarningsSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema).nullable(),
  pagination: PaginationSchema,
});

export default class EarningsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = EarningsSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
